(function(){
  'use strict';
  function markExternalBookingLinks(){
    document.querySelectorAll('a[href*="bokadirekt.se"]').forEach(function(link){
      link.setAttribute('rel','noopener');
      if(!link.getAttribute('aria-label')) link.setAttribute('aria-label',(link.textContent.trim()||'Boka tid')+' – öppnas hos Bokadirekt');
    });
  }
  function trackBookingIntent(){
    document.addEventListener('click',function(event){
      var link=event.target.closest('a[href*="bokadirekt.se"]');
      if(!link)return;
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:'booking_click',booking_source:link.closest('section')?.id||'global',booking_label:(link.textContent||'').trim()});
    });
  }
  function init(){markExternalBookingLinks();trackBookingIntent()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
